// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a2b4138e80cc0642","5489":"bf3b217b7955ee0e"}[chunkId] + ".css";
};